/**
 * Within the boundaries of this file, all non-dev environments are considered Production environments.
 * To specify different variable values for each non-dev environment, refer to the Release pipeline in Azure DevOps and modify the
 * variable groups accordingly. The same variable groups can be found under Azure DevOps > Pipelines > Library.
 * Be sure to link the newly defined variable group to the Release pipeline if it isn't already.
 */
const isProdEnvironment = process.env.NODE_ENV === 'production';

export const EnvironmentVariables = {
  /**
   * All pipeline variables referenced below must be wrapped inside the custom `#{...}#` wrapper as this is what the pipeline has been
   * configured to lookout for.
   *
   * Note that `$(...)` was considered but should NOT be used since this is already being used by jQuery. Avoiding this syntax will prevent
   * any unwanted issues/conflicts.
   */
  IPSI: {
    BASE_URL: isProdEnvironment ? '#{ipsiBaseUrl}#' : 'https://simulation-api.enterprisesecure.com.au',
    USER_NAME: isProdEnvironment ? '#{ipsiUsername}#' : 'dhl.iframe.demo',
    CONFIG_ID_IFRAME_1: isProdEnvironment ? '#{ipsiConfigIdIframe1}#' : 'dcbfdb9c-ace6-4b17-9b4b-df219bbb97bf',
    CONFIG_ID_IFRAME_2: isProdEnvironment ? '#{ipsiConfigIdIframe2}#' : '9fbc136a-ee2b-4c07-bd38-19f458abe881',
    VERIFY_MESSAGE_IFRAME_1: isProdEnvironment ? '#{ipsiVerifyMessageIframe1}#' : '3a09a20a95e556039216810af22f309693987d4206d08cddbac582bb92390725',
    VERIFY_MESSAGE_IFRAME_2: isProdEnvironment ? '#{ipsiVerifyMessageIframe2}#' : '6677d75995b584d73e3f37e15403b353a197231f5976fc6deb5a68cbcd3c0530',
    SHORT_TERM_TOKEN_TIMEOUT: isProdEnvironment ? '#{ipsiShortTermTokenTimeout}#' : '15', // `tokenControl.tokenLifeTime` in minutes
  },
  MemberPortalTimeout: {
    TIMEOUT: isProdEnvironment ? '#{memberPortalTimeout}#' : '60000',
  },
};

export default EnvironmentVariables;
